import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {Row, Col} from "react-bootstrap"
import {isString} from "lodash"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Input from "@irati/ui/src/FormItem/Input"
import Button, {TextButton} from "@irati/ui/src/Button"
import Validation from "@irati/utils/validation"
import C from "@irati/utils/constants/markdown"
import {getTrimmed} from "@irati/utils/string/"

const StyledInput = styled(Input)`
  text-align: left;
`

const PROPERTY = "redemptionInstructions"

export const schema = () => Validation
  .string("admin.components.companyBenefits.instructions.schema.validation.string")

/**
 * We are having to use an amended version of getBulletPointListItems as we want to allow
 * an empty bullet point to signify a new entry (we prevent it from being submitted through validation)
 */
const getBulletPointListItems = (str) => {
  const reBulletPointList = /(?:^|\n{2})-[\s]{1}(.*)(?:\n[\s]*|[\s]*$)/gm
  let list = []
  if (isString(str)) {
    const matchedList = str.match(reBulletPointList)
    if (matchedList) {
      list = matchedList.map((bulletPoint) => {
        return (bulletPoint.replace(C.BULLET_POINT_CHAR, "").replace(" ", "").replace(C.NEW_LINE_SEPARATOR, ""))
      })
    }
  }
  return list
}

const toString = (array) => array.map((element) => `- ${element}`).join("\n")

const toArray = (string = "") => getBulletPointListItems(string)

const handleDelete = (instructionsArray, onChange, index) => {
  const clone = instructionsArray.slice(0)
  clone.splice(index, 1)
  onChange(PROPERTY, toString(clone))
}

const handleUpdate = (instructionsArray, onChange, value, index) => {
  const newValue = value || ""
  const clone = instructionsArray.slice(0)
  clone[index] = newValue
  onChange(PROPERTY, toString(clone))
}

const handleBlur = (instructionsArray, onChange, value, index) => {
  const newValue = getTrimmed(value) || ""
  handleUpdate(instructionsArray, onChange, newValue, index)
}

const addStep = (instructionsArray, onChange) => {
  const lastItem = instructionsArray[instructionsArray.length - 1]
  if (getTrimmed(lastItem).length) {
    handleUpdate(instructionsArray, onChange, "", instructionsArray.length)
  }
}

const removeButton = (instructionsArray, onChange, index) => {
  return <TextButton onClick={() => handleDelete(instructionsArray, onChange, index)}>
    <FormattedMessage id="admin.components.companyBenefits.instructions.removeButton.textButton" />
  </TextButton>
}

const hasMoreThanOneItem = (instructionsArray) => {
  return instructionsArray.length > 1
}

const Instructions = ({benefit, onChange, formatMessage}) => {
  const instructionsArray = toArray(benefit.redemptionInstructions)
  return (
    <React.Fragment>
      <Row>
        <Col md={12}>
          { instructionsArray.map((instruction, index) =>
            <StyledInput
              key={index}
              addon={{after: hasMoreThanOneItem(instructionsArray) ? removeButton(instructionsArray, onChange, index) : null}}
              name="perkInstruction"
              label={formatMessage({id: "admin.components.companyBenefits.instructions.input.label"}, {count: index + 1})}
              type="text"
              validation={schema()}
              placeholder={formatMessage({id: "admin.components.companyBenefits.instructions.input.placeholder"})}
              value={instruction}
              onChange={(value) => handleUpdate(instructionsArray, onChange, value, index)}
              onBlur={(value) => handleBlur(instructionsArray, onChange, value, index)} />
          )}
          <Button full onClick={() => addStep(instructionsArray, onChange)}>
            <FormattedMessage id="admin.components.companyBenefits.instructions.button.text" />
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  )
}

Instructions.propTypes = {
  benefit: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired
}

export default injectIntl(Instructions)
